import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  ENUM_STATUS_WINDOW,
  setChatActiveTab,
  setLovenseEnable,
  setLovenseQueue,
  setLovenseRunning,
  setLovenseShow,
  setLovenseTips,
  setLovenseToys,
  setLovenseWaiting,
  setMessages,
  setNewMessages,
} from "../../store/chatSlice";
import { TEST_MODE } from "../../components/common/consts";
import { plugMessages, testLovenseQueue, testLovenseTips, testLovenseToys } from "../../testConst";
import { API_CHAT } from "../../api/chat";
import { infoToast } from "../../components/mui/Toaster";
import { useAppSelector } from "../../store/index.ts";
import { ENUM_CHAT_TAB, ENUM_TYPE_MES } from "../../components/common/enums.js";
import useNickname from "../site/useNickname.js";

const isLog = false;

export default function useLovense() {
  const dispatch = useDispatch();
  const broadcasterChatId = useAppSelector((state) => state.chat.broadcaster?.chat?.id);
  const levels = useAppSelector((state) => state.chat.lovense?.tips?.levels);
  const toys = useAppSelector((state) => state.chat.lovense?.toys);
  const enable = useAppSelector((state) => state.chat.lovense?.enable);
  const isShow = useAppSelector((state) => state.chat.lovense.show);
  const running = useAppSelector((state) => state.chat.lovense.queue.running);
  const queue = useAppSelector((state) => state.chat.lovense.queue.queue);
  const status = useAppSelector((state) => state.chat.statusWindow);
  const { name } = useNickname();

  const showPrev = useRef();

  const getInfo = async () => {
    // if (!chatId) return setTimeout(() => getInfo(), 1000);

    API_CHAT.lovense
      .getSetting(broadcasterChatId)
      .then((e) => {
        if (isLog) console.log("setting e", e);
        dispatch(setLovenseTips(e.data.settings));
      })
      .catch((e) => console.log(e));

    API_CHAT.lovense
      .getToys(broadcasterChatId)
      .then((e) => {
        dispatch(setLovenseEnable(e.data.enabled));
        dispatch(setLovenseToys(e.data.toys));
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (isLog) console.log("broadcasterChatId", broadcasterChatId);

    if (!broadcasterChatId) {
      dispatch(setLovenseToys({}));
      dispatch(setLovenseTips({}));
      return;
    }

    getInfo();
  }, [broadcasterChatId]);

  useEffect(() => {
    if (isLog) console.log(levels, toys, enable);

    const isToys = toys?.length;
    const isLevels = levels && Object.keys(levels)?.length;
    const isEnable = enable;

    const isShown = isLevels && isToys && isEnable;
    // const isShown = 1;
    dispatch(setLovenseShow(isShown));
    if (isLog) console.log("isShown", isShown);
  }, [levels, toys, enable]);

  useEffect(() => {
    if (!isShow && !showPrev.current) return;

    if (!isShow) {
      const msgDisconnect = { from: { type: "system" }, type: ENUM_TYPE_MES.lovenseDisconnect };
      dispatch(setChatActiveTab(ENUM_CHAT_TAB.free));
      dispatch(setNewMessages(msgDisconnect));
      showPrev.current = isShow;
      return;
    }

    const msg = { from: { type: "system" }, type: ENUM_TYPE_MES.lovenseConnect };
    dispatch(setNewMessages(msg));
    showPrev.current = isShow;
  }, [isShow]);

  useEffect(() => {
    if (isLog) console.log("running", running);

    if (!running || (typeof running === "object" && !Object.keys(running).length)) return;

    const mes = {
      from: { type: "system" },
      power: running.reactToys?.[0]?.vibrate,
      specialType: running.specialType,
      delay: running.time,
      nickName: running.tipperName,
      type: ENUM_TYPE_MES.vibratotion,
    };

    dispatch(setNewMessages(mes));
  }, [running]);

  useEffect(() => {
    for (let i = 0; i < queue.length; i++) {
      const el = queue[i];

      if (el.tipperName === name) {
        if (i === 0) return;

        const number = i + 1;
        return infoToast("Your number in the queue " + number);
      }
    }
  }, [queue, name]);

  useEffect(() => {
    if (!TEST_MODE) return;
    const { running, queue, waiting } = testLovenseQueue;

    dispatch(setLovenseQueue(queue));
    dispatch(setLovenseRunning(running));
    dispatch(setLovenseWaiting(waiting));
    dispatch(setLovenseEnable(true));
    dispatch(setLovenseTips(testLovenseTips));
    dispatch(setLovenseToys(testLovenseToys));
    dispatch(setMessages(plugMessages));
  }, []);

  useEffect(() => {
    if ([ENUM_STATUS_WINDOW.offline, ENUM_STATUS_WINDOW.endPrivate].includes(status)) {
      dispatch(setLovenseToys({}));
      dispatch(setLovenseTips({}));
    }
  }, [status]);
}
